/**
 * @module app.carousel
 */
import appSwiper from './swiper.js';

class Controller {
  /**
   * @ngInject
   * @param {jQuery} $element
   * @param {angular.Scope} $scope
   * @param {{photos: Array<Object>, rotate_hint: boolean}} appCarouselPhotos
   */
  constructor($element, $scope, appCarouselPhotos) {

    /**
     * @private
     */
    this.element_ = $element;

    /**
     * @private
     */
    this.scope_ = $scope;

    /**
     * @export
     * @type {number}
     */
    this.index = 0;

    /**
     * @export
     * @type {Array<ol.Feature>}
     */
    this.photos;

    /**
     * @private
     * @type {function()}
     */
    this.swiperDestroyer_;

    /**
     * @private
     * @type {jQuery} $element
     */
    this.carouselElement_;

    $scope.$watchCollection(() => appCarouselPhotos, () => {
      this.photos = appCarouselPhotos.photos;
      this.index = 0;
      if (this.photos.length > 0) {
        this.element_.find('.modal').modal('show');
      }
    });

    $scope.$watch(() => appCarouselPhotos.rotate_hint, () => {
      const element = this.element_.find('.rotate_hint');
      if (appCarouselPhotos.rotate_hint) {
        element.addClass('enabled');
      } else {
        element.removeClass('enabled');
      }
    });
  }

  $onInit() {
    this.carouselElement_ = this.element_.find('.carousel');
    this.carouselElement_.on('slide.bs.carousel', (event) => {
      this.index = $(event.relatedTarget).index();
      this.scope_.$apply();
    });
    // close carousel when clicking outside of the div.modal-content
    const carouselContainer_ = this.element_.find('.app-carousel-modal');
    carouselContainer_.on('click', (event) => {
      if ($(event.target).parents('.modal-content').length == 0) {
        carouselContainer_['modal']('hide');
      }
    });
    const swipeElement = this.element_.find('.carousel-inner')[0];
    if ('ontouchstart' in document.documentElement) {
      this.swiperDestroyer_ = appSwiper(swipeElement, direction => {
        switch (direction) {
          case 'left':
            this.carouselElement_['carousel']('next');
            break;
          case 'right':
            this.carouselElement_['carousel']('prev');
            break;
          default:
            // ignore
        }
      });
    }
  }

  $onDestroy() {
    if (this.swiperDestroyer_) {
      this.swiperDestroyer_();
    }
  }

  /**
   * @export
   */
  rewind() {
    setTimeout(() => {
      // Call the carousel outside the Angular loop
      // An $apply will be called by the carousel.
      this.carouselElement_['carousel'](0);
    }, 0);
  }
}


/**
 * @type {!angular.Component}
 */
const component = {
  controller: Controller,
  templateUrl: 'js/app/carousel/partial.html'
};

const name = 'appCarousel';
export default angular.module(name, [])
  .component(name, component)
  .value('appCarouselPhotos', {
    photos: []
  });
